import { getCookie } from './cookie-handler';

export function getCartCount() {
    return parseInt(getCookie('_bo_basket_count'), 10) || 0;
}

export function isLoggedIn() {
    return (parseInt(getCookie('_bo_logged_in'), 10) || 0) === 1;
}

export function getBlocksOfficeSession() {
    return getCookie('_bo_session_id') || null;
}

export function getModeOfSale() {
    return parseInt(getCookie('_bo_mos'), 10) || 5;
}

export function getPackageModeOfSale() {
    return parseInt(getCookie('_bo_package_mos'), 10) || 6;
}

export function getSourceNumber() {
    return parseInt(getCookie('_bo_source_no'), 10) || 1;
}

export function getUserEmailAddress() {
    return getCookie('_bo_user_email') || null;
}

export default {
    getCartCount,
    isLoggedIn,
    getBlocksOfficeSession,
    getPackageModeOfSale,
    getModeOfSale,
    getSourceNumber,
    getUserEmailAddress,
}
